const formatDateOnly = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const normalizeDateValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : formatDateOnly(value);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') {
      return '';
    }

    if (/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(trimmed)) {
      return trimmed.slice(0, 10);
    }

    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? trimmed : formatDateOnly(parsed);
  }

  return value;
};

const mapTokenToChoiceId = (token, options) => {
  const key = String(token ?? '').trim();
  if (!key) {
    return '';
  }

  if (!Array.isArray(options) || options.length === 0) {
    return key;
  }

  const byValue = options.find((item) => String(item.value).toLowerCase() === key.toLowerCase());
  if (byValue) {
    return String(byValue.value);
  }

  const byLabel = options.find((item) => String(item.label).toLowerCase() === key.toLowerCase());
  if (byLabel) {
    return String(byLabel.value);
  }

  return key;
};

/**
 * Value inviato al server per Choice / MultipleChoice: id delle option (CSV per multi).
 * DisplayValue resta demandato a getDisplayValue (label leggibili).
 */
export const resolveChoiceFieldSubmitValue = (fieldConfig, rawValue) => {
  const typeName = (fieldConfig.type || fieldConfig.TypeName || '').toLowerCase();
  const options = fieldConfig.options;

  if (typeName === 'choice') {
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '';
    }
    return mapTokenToChoiceId(rawValue, options);
  }

  if (typeName === 'multiplechoice') {
    const tokens = Array.isArray(rawValue)
      ? rawValue.map((item) => String(item || '').trim()).filter(Boolean)
      : String(rawValue || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);

    if (tokens.length === 0) {
      return '';
    }

    if (!Array.isArray(options) || options.length === 0) {
      return tokens.join(',');
    }

    return tokens.map((token) => mapTokenToChoiceId(token, options)).filter(Boolean).join(',');
  }

  return null;
};

export const normalizeFieldValue = (fieldConfig, rawValue) => {
  const typeName = (fieldConfig.type || fieldConfig.TypeName || '').toLowerCase();

  if (typeName === 'boolean') {
    return rawValue === true || rawValue === 'true' || rawValue === 1 ? 'true' : 'false';
  }

  if (typeName === 'date' || typeName === 'birthdate') {
    return normalizeDateValue(rawValue);
  }

  if (typeName === 'choice' || typeName === 'multiplechoice') {
    return resolveChoiceFieldSubmitValue(fieldConfig, rawValue) ?? '';
  }

  if (typeName === 'number' || typeName === 'integer') {
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '';
    }
    return String(rawValue);
  }

  return rawValue;
};
